export abstract class VehicleHistoryEvent {
    public ts: Date;
    public positionTimestamps: string[];
    public isActive: boolean;

    public selectorId: string;

    public get description() {
        return undefined;
    }
    public get title() {
        return undefined;
    }

    public abstract type: string;
}
